import React from "react";
import { FixedSizeList } from "react-window";

import type { ListChildComponentProps } from "react-window";

export const VIRTUALIZED_ITEM_HEIGHT = 40;
export const VIRTUALIZED_VISIBLE_ROWS = 7;

const VirtualizedListbox = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLElement>>(
  function VirtualizedListbox({ children, ...rest }, ref) {
    const items = React.Children.toArray(children);
    const itemCount = items.length;
    const listHeight = Math.min(itemCount, VIRTUALIZED_VISIBLE_ROWS) * VIRTUALIZED_ITEM_HEIGHT;
    return (
      <div ref={ref} {...rest} style={{ ...rest.style, overflow: "hidden", maxHeight: "none" }}>
        <FixedSizeList
          height={listHeight}
          width="100%"
          itemSize={VIRTUALIZED_ITEM_HEIGHT}
          itemCount={itemCount}
          overscanCount={6}
          style={{ overflowX: "hidden" }}
        >
          {({ index, style }: ListChildComponentProps) => (
            <div style={style}>{items[index]}</div>
          )}
        </FixedSizeList>
      </div>
    );
  }
);

export const createVirtualizedListbox = (options: {
  itemHeight?: number;
  visibleRows?: number;
}) => {
  const itemHeight = options.itemHeight ?? VIRTUALIZED_ITEM_HEIGHT;
  const visibleRows = options.visibleRows ?? VIRTUALIZED_VISIBLE_ROWS;

  return React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLElement>>(
    function CustomVirtualizedListbox({ children, ...rest }, ref) {
      const items = React.Children.toArray(children);
      const itemCount = items.length;
      const listHeight = Math.min(itemCount, visibleRows) * itemHeight;
      return (
        <div ref={ref} {...rest} style={{ ...rest.style, overflow: "hidden", maxHeight: "none" }}>
          <FixedSizeList
            height={listHeight}
            width="100%"
            itemSize={itemHeight}
            itemCount={itemCount}
            overscanCount={6}
            style={{ overflowX: "hidden" }}
          >
            {({ index, style }: ListChildComponentProps) => (
              <div style={style}>{items[index]}</div>
            )}
          </FixedSizeList>
        </div>
      );
    }
  );
};

export default VirtualizedListbox;
